var SUPERSTRONG = (!SUPERSTRONG ? {} : SUPERSTRONG);
(function ($){
	SUPERSTRONG.Overlayer = function (){


	};
	var p = SUPERSTRONG.Overlayer.prototype;
	p._inited = false;
	p._overlay = {};
	p._overlayContent = {};
	p._hashKey = 0;
	p._overlayableContent = {};



	p.init = function (){

		this._hashKey = new Date().getTime();
		this._overlay = $(document.createElement('DIV'));
		this._overlayContent = $(document.createElement('DIV'));
		this._overlayCloseControl = $(document.createElement('A'));
		this._overlay.attr('id','overlay');
		this._overlay.css({
			'display':'none'

		});
		this._overlayContent.addClass('overlay-content');
		this._overlayCloseControl.addClass('overlay-close-control');

		var clickCallBack = p.closeOverlay.bind(this);
		this._overlay.on('click','.overlay-close-delegate',clickCallBack);
		this._overlayCloseControl.on('click',clickCallBack);
		this._overlay.append(this._overlayContent);
		this._overlay.append(this._overlayCloseControl);
		$(document.body).append(this._overlay);
		$(document.body).keyup(function (e){
			if (e.keyCode === 27 && $(document.body).hasClass('has-overlay')){
				this.closeOverlay();
			}

		}.bind(this));
		this._inited = true;

		return this;
	};

	p.showOverlay = function (){

		if (!this._inited){
			this.init();
		}
		this._overlay.addClass('visible');
		$(document.body).addClass('has-overlay');
	};

	p.closeOverlay = function (){

		if (!this._inited){
			return;
		}
		this._overlay.removeClass('visible');
		$(document.body).removeClass('has-overlay');
		this._overlayContent.empty();

	};


	p.injectNodeSync = function (node){

		if (!this._inited){
			this.init();
		}
		var _clone = node.clone();
		_clone.attr('data-id',new Date().getTime());
		this._overlayContent.append(_clone);
		return _clone;

	};

})(jQuery);
